module.exports = __webpack_public_path__ + "static/media/whitelogo.9caf7c9d.png";